<template>
  <div class="home">
    <searcher/>
    <div class="clear"></div>
    <claims/>
    <div class="clear"></div>
    <profiles/>
    <div class="clear"></div>
    <newsletter/>
    <div class="clear"></div>
  </div>
</template>

<script>
  import searcher from '../components/index/searcher'
  import claims from '../components/index/claims'
  import profiles from "../components/index/profiles";
  import newsletter from "../components/index/newsletter";

  export default {
    name: 'home',
    components: {
      newsletter,
      profiles,
      searcher,
      claims
    }
  }
</script>
<style>
  .hero {
    background-image: url("../assets/images/searchBackground.jpg");
  }

</style>
